import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ConfiguratorService } from 'src/app/shared/services/configurator-service/configurator.service';
import { ToastrMsgService } from 'src/app/shared/services/shared-services/toastr.service';
import { UserService } from 'src/app/shared/services/user-services/user.service';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
  selector: 'app-configurator-provider',
  templateUrl: './configurator-provider.component.html',
  styleUrls: ['./configurator-provider.component.css'],
})
export class ConfiguratorProviderComponent {
  addProvider = false;
  selectedPartner: Array<string> = [];
  viewProvider: any = false;
  isDisabled: boolean = true; // Change this to false if you want to enable the elements
  partnerId: any;

  // {
  //   "providerName": "string",
  //   "txType": "string",
  //   "host": "string",
  //   "hostList": "string",
  //   "method": "string",
  //   "requestUrl": "string",
  //   "headerType": "string",
  //   "userName": "string",
  //   "password": "string",
  //   "code": "string",
  //   "url": "string",
  //   "port": "string"
  // }
  // Auxiliary object to keep track of selected _id values and their corresponding names
  selectedPartnerIds: { [id: string]: string } = {};

  // onItemClick(item: any, isAlreadySelected: boolean) {
  //   console.log(item._id);
  //   if (isAlreadySelected) {
  //     // If item is a string, it means we're removing a partner by name
  //     if (typeof item === 'string') {
  //       const nameToRemove = item;
  //       console.log(nameToRemove);

  //       // Find the first _id associated with the name to be removed
  //       const idToRemove = Object.keys(this.selectedPartnerIds).find(id => this.selectedPartnerIds[id] === nameToRemove);
  //       if (idToRemove) {
  //         // Remove the first occurrence of the name from the selectedPartner array
  //         const indexToRemove = this.selectedPartner.indexOf(nameToRemove);
  //         if (indexToRemove !== -1) {
  //           this.selectedPartner.splice(indexToRemove, 1);
  //         }
  //         delete this.selectedPartnerIds[idToRemove];
  //       }
  //     }
  //     return;
  //   }

  //   // Add the item's name if its _id is not already in selectedPartnerIds
  //   if (!this.selectedPartnerIds[item._id]) {
  //     console.log(this.selectedPartnerIds);

  //     this.selectedPartner.push(item.name);
  //     this.selectedPartnerIds[item._id] = item.name;
  //     console.log(Object.keys(this.selectedPartnerIds));
  //     this.providerForm?.controls['partners'].setValue(Object.keys(this.selectedPartnerIds));
  //     // this.providerForm.controls['partners'].setValue(this.selectedPartner.map(partner => partner._id));

  //   }
  // }

  commision = false;
  providerList: any = [];
  id: any;
  urlPattern =
    '^((https?|ftp|smtp):\\/\\/)?(www.)?[a-z0-9]+([\\-.]{1}[a-z0-9]+)*\\.[a-z]{2,5}' +
    '((\\/[\\w\\-]+)*\\/)?([\\w\\-]+\\.[\\w]{2,4}(\\?[\\w\\-]+=[\\w\\-]+)?)?$';
  isUpdated: boolean = false;
  providerForm!: FormGroup;
  allPartner: any;
  // selectedPartners: any; // This will hold the selected partner IDs
  searchItem: any = '';
  FilterItem: any = '';
  pagination = {
    limit: 10,
    currentPage: 1,
    userId: '',
  };
  totalPage: number = 0;
  totalRecords: any;
  permissions: any = [];
  roleType: any;
  selectedPartnerId: string = '';
  selectedPartners: string[] = [];
  partnerIds: string[] = []; // Example array of partner IDs for the edit form

  isOpen = false; // Property to track the open state of the dropdown

  private subject: Subject<string> = new Subject();
  constructor(
    private configuratorProviderService: ConfiguratorService,
    private formBuilder: FormBuilder,
    private toastrMsgService: ToastrMsgService,
    private userService: UserService
  ) {}
  ngOnInit() {
    this.providerForm = this.formBuilder.group({
      providerName: ['', Validators.required],
      txType: ['', Validators.required],
      host: ['', Validators.required],
      hostList: ['', Validators.required],
      method: ['', Validators.required],
      requestUrl: [
        '',
        [Validators.required, Validators.pattern(this.urlPattern)],
      ],
      headerType: ['', Validators.required],
      userName: ['', Validators.required],
      password: ['', Validators.required],
      code: ['', Validators.required],
      url: ['', [Validators.required, Validators.pattern(this.urlPattern)]],
      port: ['', Validators.required],
      settlementType: ['', Validators.required],
      partners: ['', Validators.required],
      targetDestination: ['', Validators.required],
    });
    this.partnerId = this.userService.getUserDetailsFromSession()._id;
    const data: any = localStorage.getItem('user');
    const dataparser = JSON.parse(data);
    if (dataparser?.role?.type === 'reseller') {
      this.pagination.userId = dataparser?.createdBy;
    } else if (dataparser?.role?.type === 'admin') {
      this.pagination.userId = '';
    } else {
      this.pagination.userId = dataparser?._id;
    }

    this.getUser(data);

    window.addEventListener('storage', (event) => {
      if (event.key === 'user') {
        const updatedData = localStorage.getItem('user');
        this.getUser(updatedData);
      }
    });

    this.subject.pipe(debounceTime(1000)).subscribe((searchTextValue) => {
      this.getAllProviderViaSearch(searchTextValue, this.pagination);
    });
    this.getAllProvider(this.pagination);
    this.getAllPartner();
    this.setPermissions('provider');
    document.addEventListener(
      'click',
      this.closeDropdownOnOutsideClick.bind(this)
    );
  }
  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }
  getSelectedPartnerName(partnerId: string): string {
    const selected = this.allPartner.find(
      (partner: { _id: string }) => partner._id === partnerId
    );
    return selected ? selected.name : 'None';
  }
  setPermissions(type: string) {
    let allPermissions = JSON.parse(localStorage.getItem('permissions') as any);
    this.permissions = allPermissions.filter((item: any) => {
      return item.category == type;
    })[0].permissions;

    console.log(this.permissions);
  }

  ngOnDestroy() {
    document.removeEventListener(
      'click',
      this.closeDropdownOnOutsideClick.bind(this)
    );
  }
  closeDropdownOnOutsideClick(event: MouseEvent) {
    const dropdown = document.querySelector('.dropdown');
    if (dropdown && !dropdown.contains(event.target as Node) && this.isOpen) {
      this.isOpen = false;
    }
  }
  getUser(data: any) {
    if (data) {
      const role = JSON.parse(localStorage.getItem('user') || '{}');

      this.roleType = role.role.type;
      console.log(
        'roleId',

        this.roleType
      );
    } else {
      console.log('No data found in local storage.');
    }
  }

  getAllProvider(pagination: any) {
    const payload = this.pagination;
    this.configuratorProviderService
      .getAllProviderWithPagination(
        payload,
        this.FilterItem,
        this.pagination.userId
      )
      .subscribe({
        next: (response) => {
          console.log('Get Provider request ', response.data.data);
          this.providerList = response.data.data;
          this.totalPage = response.data.totalPage;
          this.totalRecords = response.data.totalData;
          console.log();
        },
        error: (error) => {
          console.error('Error  getting :', error);
        },
        complete: () => {
          console.log('Get request completed');
          // clean-up logic for this
        },
      });
  }
  getAllProviderViaSearch(e: any, pagination: any) {
    pagination.currentPage = 1;
    const payload = pagination;

    this.searchItem = e.target.value;
    this.configuratorProviderService
      .getAllProviderWithSearch(payload, this.searchItem, this.FilterItem)
      .pipe(debounceTime(1000))
      .subscribe({
        next: (response) => {
          console.log('Get Provider search ', response.data.data);
          this.providerList = response.data.data;
          this.totalPage = response.data.totalPage;
          this.totalRecords = response.data.totalData;
        },
        error: (error) => {
          console.error('Error  getting :', error);
        },
        complete: () => {
          console.log('Get request completed');
          // clean-up logic for this
        },
      });
  }
  getAllProviderViaFilter(e: any) {
    this.FilterItem = e.target.value;
    const payload = this.pagination;
    this.configuratorProviderService
      .getAllProviderWithFilter(payload, this.FilterItem, this.searchItem)
      .subscribe({
        next: (response) => {
          console.log('Get Provider filter ', response.data.data);
          this.providerList = response.data.data;
          this.totalPage = response.data.totalPage;
          this.totalRecords = response.data.totalData;
        },
        error: (error) => {
          console.error('Error  getting :', error);
        },
        complete: () => {
          console.log('Get request completed');
        },
      });
  }
  onKeyUp(event: any, pagination: any) {
    this.subject.next(event);
  }
  getAllPartner() {
    this.configuratorProviderService.getAllPartner('partner').subscribe({
      next: (response: any) => {
        console.log('Get All Partner ', response);
        this.allPartner = response.data;
        console.log(this.allPartner);
      },
      error: (error) => {
        console.error('Error  getting :', error);
      },
      complete: () => {
        console.log('Get request completed');
      },
    });
  }

  openToCreate() {
    this.addProvider = true;
    this.providerForm.reset();
    this.providerForm.controls['txType'].setValue('');
    this.providerForm.controls['headerType'].setValue('');
    this.providerForm.controls['method'].setValue('');
    console.log('form', this.providerForm);
  }
  closeFormDialog() {
    this.addProvider = false;
    this.isUpdated = false;
    this.viewProvider = false;
  }
  // createProvider() {
  //   console.log('called');
  //   console.log(this.providerForm.value);

  //   if (this.providerForm.valid) {
  //     console.log(this.providerForm.value);

  //     this.configuratorProviderService
  //       .createProvider(this.providerForm.value)
  //       .subscribe({
  //         next: (response) => {
  //           this.getAllProvider(this.pagination);
  //           this.addProvider = false;
  //           console.log('Create request ', response);
  //           this.toastrMsgService.success('Provider created Successfully');
  //         },
  //         error: (error) => {
  //           console.error('Error  Creating state:', error);
  //         },
  //         complete: () => {
  //           console.log('Create request completed');
  //           // clean-up logic for this
  //         },
  //       });
  //   } else {
  //     this.providerForm.markAllAsTouched();
  //     this.toastrMsgService.warning('Please fill the mandatory fields');
  //   }
  // }
  createProvider() {
    console.log('called');
    console.log(this.providerForm.value);
    if (this.providerForm.valid) {
      console.log(this.providerForm.value);

      this.configuratorProviderService
        .createProvider(this.providerForm.value)
        .subscribe({
          next: (response) => {
            this.getAllProvider(this.pagination);
            this.addProvider = false;
            console.log('Create request ', response);
            this.toastrMsgService.success('Provider created Successfully');
          },
          error: (error) => {
            console.error('Error  Creating state:', error);
          },
          complete: () => {
            console.log('Create request completed');
            // clean-up logic for this
          },
        });
    } else {
      this.providerForm.markAllAsTouched();

      Object.keys(this.providerForm.controls).forEach((key) => {
        if (this.providerForm.controls[key].invalid) {
          console.log('Invalid field:', key);
        }
      });

      this.toastrMsgService.warning('Please fill the mandatory fields');
    }
  }

  // editForm(index: any) {

  //   console.log(index, status);

  //   this.id = this.providerList[index]._id;
  //   let getEditableObj:any = this.providerList.find(
  //     (obj: { _id: any }) => obj._id === this.id
  //   );
  //   console.log(getEditableObj);
  //   let alreadySelectedPartner:any=[];
  //   this.allPartner.forEach((element:any)=>{
  //     getEditableObj.partners.forEach((ele:any)=>{
  //       if(element._id==ele){
  //         alreadySelectedPartner.push(element);
  //       }
  //     })
  //   })
  //   this.selectedPartner=alreadySelectedPartner;
  //   this.viewProvider = false;
  //   this.addProvider = true;
  //   this.isUpdated = true;
  //   this.providerForm.patchValue(getEditableObj);
  //   console.log( this.providerForm.value);

  // }

  editForm(index: any) {
    this.id = this.providerList[index]._id;
    let getEditableObj = this.providerList.find(
      (obj: { _id: any }) => obj._id === this.id
    );
    console.log('getEditableObj', getEditableObj);
    this.addProvider = true;
    this.isUpdated = true;
    this.providerForm.patchValue(getEditableObj);
    this.selectedPartners = getEditableObj.partners.slice(); // Clone the partnerIds array
    console.log(this.selectedPartner);
  }
  onCheckboxChange(partnerId: string, event: any) {
    if (event.target.checked) {
      this.selectedPartners.push(partnerId);
      this.providerForm?.controls['partners'].setValue(this.selectedPartners);
    } else {
      this.selectedPartners = this.selectedPartners.filter(
        (id: string) => id !== partnerId
      );
    }
  }

  viewForm(index: any) {
    console.log(index, status);

    this.id = this.providerList[index]._id;
    let getEditableObj = this.providerList.find(
      (obj: { _id: any }) => obj._id === this.id
    );
    console.log('getEditableObj', getEditableObj);
    this.viewProvider = true;
    this.addProvider = false;
    this.providerForm.patchValue(getEditableObj);
    this.providerForm.disable();
    // this.headerTypeControl.disable();
  }

  updateProvider() {
    let provideFormattedPayload = { ...this.providerForm.value, id: this.id };
    if (this.providerForm.valid) {
      this.configuratorProviderService
        .UpdateProvider(provideFormattedPayload)
        .subscribe({
          next: (response) => {
            this.isUpdated = false;
            this.addProvider = false;
            this.toastrMsgService.success('Provider updated Successfully');
            this.getAllProvider(this.pagination);
            console.log('Update request ', response);
          },
          error: (error) => {
            console.error('Error  Updating state:', error);
          },
          complete: () => {
            console.log('Update request completed');
            // clean-up logic for this
          },
        });
    } else {
      this.providerForm.markAllAsTouched();
      this.toastrMsgService.warning('Please fill the mandatory fields');
    }
  }

  nextPage() {
    if (this.pagination.currentPage < this.totalPage) {
      this.pagination.currentPage++;
      this.getAllProvider(this.pagination);
    }
  }

  // Method to handle previous page
  previousPage() {
    if (this.pagination.currentPage > 1) {
      this.pagination.currentPage--;
      this.getAllProvider(this.pagination);
    }
  }

  onLast() {
    this.pagination.currentPage = this.totalPage;
    this.getAllProvider(this.pagination);
  }
  onFirst() {
    this.pagination.currentPage = 1;
    this.getAllProvider(this.pagination);
  }

  onPageChange(page: any) {
    this.pagination.currentPage = page;
    this.getAllProvider(this.pagination);
  }

  // Method to handle previous page
  lastPage() {
    this.pagination.currentPage = this.totalPage;
    this.getAllProvider(this.pagination);
  }
}
